import { controls } from "../../controls";

const rp609 = {
  label: "STATEMENT SHOWING THE EXPOSURE UNITWISE IN RESPECT OF SPINNING SECTOR",
  pageLabel: "STATEMENT SHOWING THE EXPOSURE UNITWISE IN RESPECT OF SPINNING SECTOR",
  starting: true,
  url: "rp609",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({ tab: "filter", label: "Taluka", width: "col-sm-2" }),
    ...controls.Taluka({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "taluka_display", name: "taluka_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2", displaytype: 'small' }),


    ...controls.displayText({ tab: "filter", label: "As on Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "as_on_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-3 " }),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-1" }),
    ...controls.perPage({ tab: 'filter' }),
  ],

  //form: [
  //  ...controls.displayText({ label: "Crop Type Code", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //  ...controls.displayText({ label: "Crop Type Desc", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type_display", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //],
  form: [],

  history: {
    perPage: 10,
    reportHeader: "STATEMENT SHOWING THE EXPOSURE UNITWISE IN RESPECT OF SPINNING SECTOR",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    clickable: true, //?
    displayColumns: [

      {

        Header: "A/c code",
        accessor: "acctcode",
        width: 150

      },

      {

        Header: "A/c Name",
        accessor: "descn",
        width: 200

      },


      {
        Header: "Working Capital",
        columns: [
          {
            Header: "Date Of Sanction",
            accessor: "wcdate"
          },
          {
            Header: "Amount Sanction",
            accessor: "wcsanction",
            type: "currency"
          },
          {
            Header: "Amount Outstanding",
            accessor: "wcoutstanding",
            type: "currency"
          }

        ]
      },



      {
        Header: "Term Loan",
        columns: [
          {
            Header: "Date Of Sanction",
            accessor: "termdate",
            type: "date"

          },
          {
            Header: "Purpose",
            accessor: "termpurpose"
          },
          {
            Header: "Amount Sanction",
            accessor: "termsanction",
            type: "currency"
          },
          {
            Header: "Amount Outstanding",
            accessor: "termoutstanding",
            type: "currency"
          },
          {
            Header: "Amount Undisbursed",
            accessor: "termundisbursed",
            type: "currency"
          }

        ]
      },


      {
        Header: "Non Fund Facility",
        columns: [
          {
            Header: "Date Of Sanction",
            accessor: "nffdate"
          },
          {
            Header: "Amount Sanction",
            accessor: "nffsanction",
            type: "currency"
          },
          {
            Header: "50%",
            accessor: "nff50",
            type: "currency"
          },

          {
            Header: "Exposure",
            accessor: "explorer",
            type: "currency"
          }

        ]
      }



    ]
  }
};

export default rp609;